import React, {ReactElement} from 'react';

import ToolsView from './tools.view';

const ToolsController = (): ReactElement => {
  return <ToolsView />;
};

export default ToolsController;
